
// Логотип на стр. авторизации
import logo from './logoAuthPage.svg'

// Фоновая картинка на стр. авторизации, стать клиентом
import bgAuth from './auth-bg.jpg'

// Ссылка у кнопки Веб-сайт Постачальника 
export const SITE_LINK = 'https://www.google.com/'

// Название поставщика (ключ для перевода из файла локализации)
export const NAME_PROVIDER = 'ТОВ «Приклад»'
export const CRUMB_MAIN_TEXT = 'ТОВ «Приклад»'

export { logo as AUTH_LOGO }
export { bgAuth as AUTH_BG_BODY }
